import { jsx } from 'react/jsx-runtime';
import { createElement } from 'react';
import { IconWrapper } from '../IconWrapper/IconWrapper.js';
import '../../../tslib.es6-a39f91fc.js';
import '../../../index-6ea95111.js';
import '../../../style-inject.es-1f59c1d0.js';

var Heart = (function (props) {
    return createElement(IconWrapper, props, jsx("path", { stroke: "currentColor", strokeWidth: 2, d: "M17.388 2.698c-2.717 0-4.207 1.687-5.388 2.856-1.181-1.17-2.67-2.856-5.388-2.856-2.717 0-5.527 2.563-5.387 6.226 0 5.2 7.045 9.778 10.775 12.378 3.73-2.6 10.775-7.178 10.775-12.378.14-3.663-2.67-6.226-5.387-6.226Z" }));
});

export default Heart;
//# sourceMappingURL=Heart.js.map
